<template>
  <div class="py-1">
    <validation-observer v-slot="{handleSubmit}" ref="formObs" tag="div">
      <form @submit.prevent="handleSubmit(next)">
        <div class="d-flex flex-column flex-md-row mx-n2">
          <div class="px-2 order-1 order-md-0">
            <v-row dense>
              <v-col cols="12" lg="6" xl="4" v-if="payment_type === 'card'">
                <div class="d-flex">
                  <custom-select
                      no-data-text="Карта еще не добавлена"
                      item-text="pan"
                      class="flex-grow-1"
                      :items="cards"
                      v-model="formData.user_card_id"
                      rules="required"
                      label="Банковская карта"
                      vid="user_card_id"
                  ></custom-select>
                  <btn-with-tooltip @click="createCardDialogShowHandler" class-name="action-btn ml-2 mt-1"
                                    color="primary">
                    <v-icon small>fas fa-plus</v-icon>
                    <template #tooltip>Добавить карту</template>
                  </btn-with-tooltip>
                </div>
              </v-col>
              <v-col cols="12" lg="6" xl="4">
                <custom-select
                    :disabled="!isEnabledFormElements"
                    :items="tariffs"
                    @input="changeTariff"
                    v-model="formData.mko_tariff_id"
                    rules="required"
                    label="Тариф филиала"
                    vid="mko_tariff_id"
                ></custom-select>
              </v-col>
              <v-col cols="12" lg="6" xl="4">
                <money-input
                    :disabled="!isEnabledFormElements"
                    v-model="formData.amount"
                    :rules="{
                          required: true,
                          min_value: (selectedTariff&& selectedTariff.min_amount),
                          max_value: (selectedTariff&& selectedTariff.max_amount)
                    }"
                    vid="amount"
                    label="Сумма кредита"
                ></money-input>
              </v-col>
              <v-col cols="12" lg="6" xl="4">
                <money-input
                    :disabled="!isEnabledFormElements"
                    v-model="formData.initial_payment"
                    vid="initial_payment"
                    label="Первоначальный взнос"
                ></money-input>
              </v-col>
              <v-col cols="12" lg="6" xl="4">
                <custom-input-text
                    only="number"
                    pattern="##"
                    rules="required|max_value:28"
                    name="Ежемесячный платеж"
                    vid="payment_date"
                    :disabled="!isEnabledFormElements"
                    v-model="formData.payment_date"
                    label="Ежемесячный платеж (до этого числа)"
                ></custom-input-text>
              </v-col>
              <v-col cols="12" lg="6" xl="4">
                <div class="d-flex ma-n2">
                  <div class="pa-2 flex-grow-1">
                    <custom-input-text
                        :disabled="!isEnabledFormElements"
                        class="flex-grow-1"
                        vid="period"
                        only="number"
                        v-model="formData.period"
                        :rules="{
                          required: true,
                          min_value: (selectedTariff&& selectedTariff.min_period),
                          max_value: (selectedTariff&& selectedTariff.max_period)
                        }"
                        label=" Период (мес.)"
                        name="Период"
                    ></custom-input-text>
                  </div>
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" lg="6" xl="4">
                <custom-text-textarea
                    :disabled="!isEnabledFormElements"
                    class="flex-grow-1"
                    vid="details"
                    v-model="formData.details"
                    label="Название товара"
                    height="110"
                    hide-details
                    name="Детали"
                ></custom-text-textarea>
              </v-col>
              <v-col cols="12" lg="6" xl="4">
                <custom-text-textarea
                    hide-details
                    height="110"
                    :disabled="!isEnabledFormElements"
                    class="flex-grow-1"
                    vid="comment"
                    v-model="formData.comment"
                    label="Комментарий к кредиту"
                ></custom-text-textarea>
              </v-col>
              <v-col cols="12" lg="6" xl="3" class="text-right" v-if="payment_type === 'card'">
                <v-checkbox
                    :disabled="!isEnabledFormElements"
                    vid="turn_autopayment"
                    label="Автосписание с карты" class="mt-0" dense hide-details
                    v-model="formData.turn_autopayment"></v-checkbox>
              </v-col>
            </v-row>
          </div>
          <div class="px-2 flex-shrink-0 tariff-info order-0 order-md-1">
            <div class="dashed-card mb-2" :class="{'fade-animation-forward': isChangedTariff}" v-if="selectedTariff">
              <v-list-item dense>
                <v-list-item-title>Название: {{ selectedTariff.name }}</v-list-item-title>
              </v-list-item>
              <v-list-item dense>
                <v-list-item-title>Тип: {{ selectedTariff.type }}</v-list-item-title>
              </v-list-item>
              <v-list-item dense>
                <v-list-item-title>Процент: {{ selectedTariff.percent }}%</v-list-item-title>
              </v-list-item>
              <v-list-item dense>
                <v-list-item-title>Льготный период (мес.): {{ selectedTariff.passive_period }}</v-list-item-title>
              </v-list-item>
              <v-list-item dense>
                <v-list-item-title>Минимальная сумма: {{ selectedTariff.min_amount|money }}</v-list-item-title>
              </v-list-item>
              <v-list-item dense>
                <v-list-item-title>Максимальная сумма: {{ selectedTariff.max_amount|money }}</v-list-item-title>
              </v-list-item>
              <v-list-item dense>
                <v-list-item-title>Минимальный срок (мес.): {{ selectedTariff.min_period }}</v-list-item-title>
              </v-list-item>
              <v-list-item dense>
                <v-list-item-title>Максимальный срок (мес.):{{ selectedTariff.max_period }}</v-list-item-title>
              </v-list-item>
            </div>
          </div>
        </div>
        <div class="d-flex justify-space-between flex-wrap pt-4 ma-n2 flex-column flex-sm-row">
          <div class="pa-2">
            <v-btn :width="$vuetify.breakpoint.mdAndDown ? '100%' : null" :disabled="!canGetGraph" color="success"
                   @click="getPaymentGraph">Получить график погашения
            </v-btn>
          </div>
          <div class="pa-2">
            <v-btn :width="$vuetify.breakpoint.mdAndDown ? '100%' : null" class="text-right float-right"
                   color="primary" :disabled="!isEnabledFormElements" type="submit">Далее
            </v-btn>
          </div>
        </div>
      </form>
    </validation-observer>
    <create-card-dialog
      :isCardTypeUzcard="isCardTypeUzcard"
      ref="createCardDialog"
                        :mko_id="mko_id" @save="onSavedCard"
                        v-model="createCardDialog"></create-card-dialog>
    <payment-graph :data="paymentGraph" v-model="paymentGraphDialog"/>
  </div>
</template>

<script>
import {messages} from "@/utils/constants";
import CreateCardDialog from "@/components/card/CreateCardDialog";
import MoneyInput from "@/plugins/vuetify/components/MoneyInput";
import {removerSpace} from "@/utils/pureFunctions";
import PaymentGraph from "@/components/credit/PaymentGraph";

export default {
  components: {PaymentGraph, MoneyInput, CreateCardDialog},
  props: {
    isCardTypeUzcard: {
      type: Boolean,
      default: false
    },
    tariffs: {
      type: Array
    },
    mkos: {
      type: Array
    },
    mko_id: {},
    user_id: {},
    worker_id: {},
    payment_type: {},
    cards: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      selectedTariff: null,
      paymentGraph: [],
      paymentGraphDialog: false,
      createCardDialog: false,
      isChangedTariff: false,
      formData: {
        user_card_id: null,
        mko_tariff_id: null,
        amount: null,
        period: null,
        turn_autopayment: true,
        payment_date: null,
        initial_payment: null,
        details: null,
        phone: null
      },
    }
  },
  methods: {
    getPaymentGraph() {
      const {formObs: {handleSubmit}} = this.$refs
      handleSubmit(async () => {
        try {
          let {amount, mko_tariff_id, period, payment_date, initial_payment} = this.formData
          if (!initial_payment) initial_payment = '0'
          const formData = {
            mko_tariff_id,
            amount: removerSpace(amount) - removerSpace(initial_payment),
            period,
            payment_date: removerSpace(payment_date)
          }
          this.$showLoading()
          const {data: {data}} = await this.$http.post('admin/credits/payment/table', formData)
          this.paymentGraph = data
          this.paymentGraphDialog = true
        } catch (e) {
          this.$setResponseError({error: e})
        } finally {
          this.$clearLoading()
        }
      })
    },
    createCardDialogShowHandler() {
      if (this.mko_id) {
        this.createCardDialog = true
      } else {
        this.$emit('exception:mko_id', messages.selectMkoBeforeCreateCard)
      }


    },
    onSavedCard(data) {
      const {card_id, pan, phone} = data
      const userPhone = phone.toString();
      this.formData.user_card_id = card_id
      this.formData.phone = userPhone.substring(3)
      this.cards.push({
        id: card_id,
        pan
      })
    },
    async next() {
      this.$showLoading()
      try {
        const {payment_type, mko_id, worker_id} = this
        const formData = {...this.formData, payment_type, worker_id}
        formData.mko_id = mko_id
        if (this.user_id) formData.user_id = this.user_id
        if (formData.amount) formData.amount = removerSpace(formData.amount)
        if (formData.initial_payment) {
          formData.initial_payment = removerSpace(formData.initial_payment)
        } else {
          formData.initial_payment = 0
        }
        const {data: {data}} = await this.$http.post('admin/credits/create/step-two', formData)
        if (formData.phone) data.phone = formData.phone
        this.$emit('apply', data)
      } catch (e) {
        this.$setResponseError({error: e})
        this.$setFormError({error: e, obs: this.$refs['formObs']})
      } finally {
        this.$clearLoading()
      }
    },
    changeTariff(val) {
      if (val) {
        const tariff = this.tariffs.find(item => item.id === val)
        this.isChangedTariff = true
        setTimeout(() => {
          this.isChangedTariff = false
        }, 1000)
        if (tariff) {
          const {name, type, percent, passive_period, min_amount, max_amount, min_period, max_period} = tariff
          this.selectedTariff = {name, type, percent, passive_period, min_amount, max_amount, min_period, max_period}
          return
        }
      }
      this.selectedTariff = null
    }
  },
  computed: {
    canGetGraph() {
      const {payment_date, amount, period, mko_tariff_id} = this.formData
      return [payment_date, amount, period, mko_tariff_id].every(item => !!item)
    },
    isSelectedMko() {
      return !!this.mko_id
    },
    isSelectedCard() {
      return !!this.formData.user_card_id
    },
    isEnabledFormElements() {
      return (this.isSelectedMko && this.isSelectedCard) || this.payment_type === 'cash'
    }
  }
}
</script>
